import PropTypes from 'prop-types';
export const radioIconPropTypes = {
  /**
   * Label
   */
  label: PropTypes.string,
  /**
   * Icon name
   */
  icon: PropTypes.string,
  /**
   * Name
   */
  name: PropTypes.string,
  /**
   * value
   */
  value: PropTypes.string
};